import { render, staticRenderFns } from "./PopupView.vue?vue&type=template&id=84c55a64"
import script from "./PopupView.ts?vue&type=script&lang=ts&external"
export * from "./PopupView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports